import { Factory } from "@/data/dao/Factory";
import { DaoError } from "@/data/dao/service/BaseServiceDao";
import { DiscountsDao } from "@/data/dao/service/DiscountsDao";
import type { IDiscount } from "@/data/model/Discount";
import type { IUpdateDiscountCmd } from "@/data/queries/discounts/IUpdateDiscountCmd";

import { type VueComponentInstance, createVueComponent } from "@/shared/utils/vue";

import DiscountEditForm from "@/portal/components/discounts/DiscountEditForm.vue";
import { BaseEntityForm } from "@/portal/forms/BaseEntityForm";

export class DiscountForm extends BaseEntityForm<IDiscount, IUpdateDiscountCmd> {
    private discountEditForm: VueComponentInstance<typeof DiscountEditForm>;

    constructor(element: JQuery) {
        super(element, Factory.getInstance(DiscountsDao));

        const componentResult = createVueComponent(DiscountEditForm, {}, this.$form.find(".discount-edit-form")[0]);
        this.discountEditForm = componentResult.mountedComponent;
    }

    public setFormData(model?: IDiscount) {
        this.discountEditForm.setFormData(model, this.$saveBtn);
    }

    public getFormData(): IUpdateDiscountCmd | undefined {
        let hasError = false;
        if (!this.discountEditForm.validate()) {
            hasError = true;
        }

        if (hasError) {
            this.scrollToFirstErrorField();
        }

        const data: IUpdateDiscountCmd = this.discountEditForm.getData() as any;

        return hasError ? undefined : data;
    }

    protected resolveErrorMessage(e, b: DaoError): string | undefined {
        return this.discountEditForm.resolveErrorMessage(e, b);
    }
}
